import { IIngressEventValidationModel } from './IIngressEventFormValidation';
import { InputElementModel } from './InputElementModel';

const requestAttribute: InputElementModel = {
  name: 'requestAttribute',
  value: '',
  error: '',
  isValid: true,
  isTouched: false
};
const mqRequestMapping: InputElementModel = {
  name: 'mqRequestMapping',
  value: '',
  error: '',
  isValid: true,
  isTouched: false
};

const payloadToQueryPath: InputElementModel = {
  name: 'payloadToQueryPath',
  value: '',
  error: '',
  isValid: true,
  isTouched: false
};

const payloadToRequestHeader: InputElementModel = {
  name: 'payloadToRequestHeader',
  value: '',
  error: '',
  isValid: true,
  isTouched: false
};

const headerToRequestHeader: InputElementModel = {
  name: 'headerToRequestHeader',
  value: '',
  error: '',
  isValid: true,
  isTouched: false
};

const headerToRequestPayload: InputElementModel = {
  name: 'headerToRequestPayload',
  value: '',
  error: '',
  isValid: true,
  isTouched: false
};

const requestToAuthenticationPayload: InputElementModel = {
  name: 'requestToAuthenticationPayload',
  value: '',
  error: '',
  isValid: true,
  isTouched: false
};

export class IngressEventFormData implements IIngressEventValidationModel {
  requestAttribute: InputElementModel;

  mqRequestMapping: InputElementModel;

  payloadToQueryPath: InputElementModel;

  payloadToRequestHeader: InputElementModel;

  headerToRequestHeader: InputElementModel;

  headerToRequestPayload:InputElementModel;

  requestToAuthenticationPayload: InputElementModel;

  constructor() {
    this.requestAttribute = requestAttribute;
    this.payloadToQueryPath = payloadToQueryPath;
    this.mqRequestMapping = mqRequestMapping;
    this.payloadToRequestHeader = payloadToRequestHeader;
    this.headerToRequestHeader = headerToRequestHeader;
    this.headerToRequestPayload = headerToRequestPayload;
    this.requestToAuthenticationPayload = requestToAuthenticationPayload;
  }
}
